import axios from "axios";
import axiosRetry from "axios-retry";
import toastr from "toastr";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import cuestionarioServices from "./cuestionario.services";

const client = axios.create({ baseURL: process.env.REACT_APP_URL });
axiosRetry(client, { retries: 5, retryDelay: axiosRetry.exponentialDelay });

export const getCuestionariosById =
  (id, setRespuestasF, idEncuesta) => async (dispatch) => {
    try {
      dispatch({
        type: actions.LOADING_CUESTIONARIO,
        payload: true,
      });
      const resp = await cuestionarioServices.getCuestionariosById(id);
      let _data = resp.data;
      let _resp = {
        respuestas: [],
        clima_encuesta_id: idEncuesta,
      };
      _data.list_preguntas.map((item) => {
        _resp.respuestas.push({
          encuesta: idEncuesta,
          pregunta: item.id,
          respuesta: "",
          opcion: [],
        });
      });
      setRespuestasF(_resp);
      dispatch({
        type: actions.GET_CUESTIONARIO,
        payload: _data,
      });
      dispatch({
        type: actions.CUESTIONARIO_FAIL,
        payload: null,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = ex.response.data.mensaje;
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            case 403:
              if (ex.response.data && ex.response.data.detail) {
                message = ex.response.data.detail;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      dispatch({
        type: actions.CUESTIONARIO_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_CUESTIONARIO,
        payload: false,
      });
    }
  };

export const saveCuestionariosAnswers =
  (req, history, userId, userType) => async (dispatch) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_CUESTIONARIO,
        payload: true,
      });
      await cuestionarioServices.saveCuestionariosAnswers(req);
      // dispatch({
      //   type: actions.GET_CUESTIONARIO,
      //   payload: resp.data,
      // });
      dispatch({
        type: actions.FORM_FAIL,
        payload: null,
      });
      alert("Muchas gracias por su tiempo");
      toastr.success("Realizado con éxito");
      history.push(`/detalle-empleado/${userId}/${userType}`);
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = ex.response.data.mensaje;
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            case 403:
              if (ex.response.data && ex.response.data.detail) {
                message = ex.response.data.detail;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      dispatch({
        type: actions.CUESTIONARIO_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_CUESTIONARIO,
        payload: false,
      });
    }
  };
